import { Component, Input } from '@angular/core';

import { MAX_BUYERS_LIST_ROWS } from '@modules/upload-buyers/pages/home/home.component';

export type TitleHelpContentType = 'my-deals' | 'upload-buyers';

@Component({
  selector: 'app-shared-title-help',
  templateUrl: './title-help.component.html',
  styleUrls: ['./title-help.component.scss'],
})
export class TitleHelpComponent {
  @Input({ required: true }) content: TitleHelpContentType = 'my-deals';

  protected isOpen = false;
  protected maxBuyersListRows = MAX_BUYERS_LIST_ROWS;
}
